import React from "react";
import Link from "gatsby-link";
import styled, { injectGlobal } from "styled-components";
import Slider from "react-slick"
import slickStyles01 from "slick-carousel/slick/slick.css"
import slickStyles02 from "slick-carousel/slick/slick-theme.css"
import customArrow from '../svg/right-circle.svg'
import downCircleWhite from '../svg/right-circle-white.svg'
import * as vars from "../style/vars";
import { above, below } from "../style/functions";
import { RichText, Date } from 'prismic-reactjs';

const Photo = ({ slides, fixText, hero, theme, mini = false, adaptiveHeight = false, isNewsCard = false }) => {
   var settings = {
     fade: true,
     infinite: true,
     speed: 2000,
     slidesToShow: 1,
     slidesToScroll: 1,
     autoplay: true,
     autoplaySpeed: 4000,
     pauseOnHover: false,
     waitForAnimate: false,
     dots: true,
     adaptiveHeight: adaptiveHeight,
   };

   let textInput = React.createRef();

   const onClickScroll = () => {
      if (typeof window !== `undefined`) {
         let scrollDistance = window.pageYOffset
         window.scrollTo({
            top: scrollDistance + window.innerHeight,
            behavior: "smooth"
         })
      }
   }

   return (
      <Container isHero={hero} mini={mini} isNewsCard={isNewsCard}>
         <Slider {...settings} className="slider" >
            {slides
               .map((slide, index) => (
                  <Slide key={index} innerRef={textInput} adaptiveHeight={adaptiveHeight} >

                     <picture className={"anchor-" + slide.image_anchor}>
                        {slide.img.mobile && <source srcSet={slide.img.mobile.url} media="(max-width: 840px)" />}
                        {slides[0].link ?
                           <Link to={slides[0].link} >
                              <img src={slide.img.url} alt={slide.img.alt} draggable={false} />
                           </Link>
                        :
                           <img src={slide.img.url} alt={slide.img.alt} draggable={false} />
                        }
                     </picture>
                  </Slide>
               ))}
         </Slider>

         {!!fixText &&
            <div className="grid ">
               <div className="inner" >
                  { (Object.keys(slides[0].logo).length > 0 || slides[0].header.length > 0 || slides[0].subheader.length > 0) && (
                    <MainCopy className="col col-xs-12 col-06 ">
                      {slides[0].logo && (
                        <img src={slides[0].logo.url} />
                      )}
                      {RichText.render(slides[0].header)}
                      {RichText.render(slides[0].subheader)}
                    </MainCopy>
                  )}
                  { (slides[0].text.length > 0 || slides[0].link !== null) && (
                     <Text isHero={hero} className="col col-xs-12 col-04">
                        {RichText.render(slides[0].text)}

                        {/* if no link, no show. if external link, target blank. if linked to booking, show special format. else show Enquire Now */}
                        {!slides[0].link ? '' : slides[0].link.includes('http') ?
                           <a className="btn btn-arrow" href={`${slides[0].link}`} target="_blank" ><span>Read More</span> </a>
                           :
                           slides[0].link.includes('booking') ?
                           <Link className="btn btn-square" to={slides[0].link}>
                              <span>
                                 Book an appointment
                                 </span>
                           </Link>
                           : slides[0].link && <Link className="btn btn-square white" to={slides[0].link}>
                           <span>
                              Enquire Now
                              </span> </Link>
                        }
                     </Text>
                  )}
               </div>
            </div>
         }

      </Container>
   );
};

injectGlobal`
   ${slickStyles01}
   ${slickStyles02}
`

const Container = styled.div`
   padding: 0;
   position: relative;
   width: ${props => props.isNewsCard ? '100%' : props.isHero ? '100%' : '94%'};
   margin: auto;
   padding-bottom: ${vars.padding.inner * 2}rem;
	 ${below.tablet`
	 	padding-bottom: 0;
	 `}
	 ${props => !props.isHero && below.tablet`
	 	.grid{
			 padding-left: 0;
			 padding-right: 0;
		 }
	 `};
	 ${props => props.mini && below.mobile`
		 img, source{
			 height: auto !important;
			 min-height: 0 !important;
		 }
		 .slick-arrow{
			 display: none !important;
		 }
		 .slick-dots{
			 left: 0 !important;
			 transform: none !important;
		 }
		 .slick-dots li{
			 margin: 0;
			 &.slick-active button:before{
				background: #3f3e3e !important;
            opacity: 1;
			}
		 }
		 .slick-dots li button{
			 border: 1px solid #3f3e3e !important;

		 }
		 .slick-dots li button, .slick-dots li button:after, .slick-dots li button:before {
			 width: 12px !important;
			 height: 12px !important;
		 }
	 `};

   .grid {
      margin: 7rem auto;

      ${below.mobile`
         margin: 3rem auto 7rem auto;
		`}
   }
    
   .slick-arrow {
      width: auto;
      height: auto;
      right: auto;
      margin: 0 4vw;
      z-index: 3;

      &:hover {
         opacity: 1;
      }
      &:before {
         content: '';
         display: block;
         width: 8vw;
         max-width: 3.5rem;
         height: 8vw;
         max-height: 3.5rem;
         background: url(${downCircleWhite}) no-repeat;
      }

      ${below.tablet`
         top: ${props => props.isNewsCard ? 'auto' : '80vmin'};
         bottom: ${props => props.isNewsCard ? '20px' : 'auto'};
         transform: none;
         margin: 0 1vw;
      `};
   }

   .slick-prev {
      right: 5rem;
      &:before {
         transform: scaleX(-1);
      }
      ${below.tablet`
         left: 1rem;
      `};
   }

   .slick-next {
      right: 0;
      ${below.tablet`
         left: 5rem;
      `};
   }
	 .slick-dots {
      margin-left: 17rem;
      bottom: 9%;
      width: auto;
      list-style: none;
      text-align: center;
      li {

			 button {
         background: transparent;
         border: 1px solid white;
         border-radius: 50%;
				 width:20px;
				 height:20px;
				 &:before, &:after{
					width:20px;
				 height:20px;
				 }
         :hover:before {
            background: white;
            opacity: 1;
         }
         :before {
            content: '';
            background-color: white;
            border-radius: 50%;
            opacity: 0;
            transition: opacity .5s;
         }
      }
			&.slick-active button:before{
				background: white;
            opacity: 1;
			}
	 }

      ${below.tablet `
         margin: 0;
         left: 50%;
         bottom: ${props => props.isNewsCard ? '20px' : '3%'};
         transform: translateX(-50%);
      `}
   }

   h3 {
		font-family: ${vars.fonts.main};
		font-weight:normal;

		font-size:2.3rem;
		font-weight: normal;
		${below.tablet`
			font-size:2.3rem;
		`}
		${below.mobile`
			font-size:2rem;
		`}
      padding-bottom: ${vars.padding.mobInner}rem;
   }
	 .grid .col{
		 min-height: 30rem;
		 ${below.tablet`
		 	min-height: 0;
			 padding-left: ${vars.padding.mobInner}rem;
			 border-left: 1px solid ${vars.colors.body};

		 `}
	 }
   .grid .col:first-of-type {
      border-left: 1px solid ${vars.colors.body};
			padding-left: ${vars.padding.inner}rem;
			${below.tablet`
				padding-left: ${vars.padding.mobInner}rem;
			`}
   }

   .border-left {
      border-left: 1px solid ${vars.colors.body};
			padding-left: ${vars.padding.inner}rem;
   }
   .mob-border-left {
      border-left-width: 0;
			padding-left: ${vars.padding.inner}rem;

      ${below.tablet`
         border-left-width: 0.2rem;
      `}
   }
`

const Slide = styled.div`
   margin-bottom: ${vars.padding.inner}rem;

   &:last-child {
      margin-bottom: 0;
   }

   img, source {
      width: 100%;
      height: ${props => props.adaptiveHeight ? 'auto' : '70vh'};
      min-height: ${props => props.adaptiveHeight ? '0' : '35rem'};
      object-fit: cover;
   }
	 .anchor-Bottom {
      img, source {
         object-position: bottom;
      }
	 }
   .anchor-Top {
      img, source {
         object-position: top;
      }
   }
   .anchor-Center {
      img, source {
         object-position: center;
      }
   }
   ${below.tablet`
      margin-bottom: ${vars.padding.inner * 3}vmin;
   `}
`

const MainCopy = styled.div`
   padding-bottom: ${vars.padding.inner}rem;
   padding-right: ${vars.padding.inner}rem;
   border-right: ${props => props.isHero ? '1' : '1'}px solid ${vars.colors.body};
	img{
		width: 200px;
	}
   ${below.tablet`
      padding-bottom: 0;
      border-right: none;
   `};

`

const Text = styled.div`
   padding-left: ${vars.padding.inner}rem;

   ${below.tablet`
      border-left: none;
      padding-left: 0;
   `};

   h4 {
      padding-bottom: 3rem;
   }
   h5 {
      font-size: ${vars.padding.inner / 2}rem;
      padding-bottom: ${vars.padding.inner / 5}rem;

   }
`

const BookNow = styled(Link)`
   white-space: nowrap;
   background: white;
   padding: 1.2rem 1.75rem;
   border-radius: 4px;
   text-decoration: none;
   border-radius: 4px;
   border: ${props => props.theme !== 'white' ? 'inherit' : `1px solid #e0e0e0`};

   &.btn-square {
      display: inline-block;
      width: auto;
      font-size: 2.2rem;

      &:hover {
         margin: 0;
         &:after {
            margin-left: 1rem;
         }
      }

      &:after {
         content: '→';
         margin-left: .6rem;
         transition: margin-left .3s;
      }

      ${below.tablet`
         font-size: 1.4rem;
      `};
   }
`

const DownArrow = styled.div`
   display: ${props => props.isHero ? 'block' : 'none'};
   position: absolute;
   top: 60vmin;
   width: 3rem;
   height: 3rem;

   &:after {
      position: absolute;
      display: inline-block;
      content: "";
      width: 4rem;
      height: 4rem;
      background: url(${downCircleWhite});
      transform: rotate(90deg);
      vertical-align: middle;
      cursor: pointer;
   }

   ${below.tablet`
      visibility: hidden;
   `};

`


export default Photo;



// WEBPACK FOOTER //
// ./src/components/photo.js